export default __webpack_public_path__ + "static/media/65.9917cc9b.svg";